import PropTypes from "prop-types";
import { isWithinInterval } from "date-fns";

const shouldRender = (startDate, endDate) => {
  try {
    return isWithinInterval(new Date(), {
      start: new Date(startDate),
      end: new Date(endDate),
    });
  } catch (error) {
    return false;
  }
};

const OnTimeRender = ({ startDate, endDate, children = null }) =>
  shouldRender(startDate, endDate) ? children : null;

OnTimeRender.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
};

export default OnTimeRender;
